module.exports = __webpack_public_path__ + "static/media/logo-cpca.62ca3e3d.png";